import { createAction, props } from '@ngrx/store';
import type { DrivePickerFileMetadata } from '../../common/services/drive-picker/drive-picker.models';

export const openDrivePicker = createAction('[DrivePicker] Open');

export const drivePickerFileSelected = createAction(
  '[DrivePicker/API] File Selected',
  props<{ file: DrivePickerFileMetadata }>()
);

export const drivePickerCancelled = createAction(
  '[DrivePicker/API] Cancelled'
);

export const drivePickerError = createAction(
  '[DrivePicker/API] Error',
  props<{ error: string }>()
);

export const clearDrivePickerSelection = createAction(
  '[DrivePicker] Clear Selection'
);
